<app-dialog-header title="Zeile bearbeiten" (close)="onCancel()"></app-dialog-header>

<mat-dialog-content>
  <lib-table-vertical-control-core
    [groups]="groups()"
    (selectionDataChange)="onSelectionDataChange($event)"
  />
</mat-dialog-content>

<div mat-dialog-actions style="margin-top: 1rem">
  <app-confirm-icon-button
    (customClick)="onConfirm()"
    matTooltip="Änderungen bestätigen"
  ></app-confirm-icon-button>
</div>
